import styled from 'styled-components'

export const MobilePlaybackSpeedSheet = styled.div`
  width: 100%;
  height: 100%;

  padding: 16px;

  display: flex;
  flex-direction: column;
`

export const MobilePlaybackSpeedOptionsRow = styled.div`
  margin-bottom: 20px;

  display: flex;
  gap: 12px;
  overflow: overlay hidden;
  scrollbar-width: none;

  ::-webkit-scrollbar {
    display: none;
  }
`
